export default __webpack_public_path__ + "static/media/FAC7.052374d5.jpg";